import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const StudyIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="gym-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 103.2 72.8"
    className={twMerge('h-6 w-6 stroke-current', className)}
    {...props}
  >
    <path fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="5" d="M70.2 37.2h30.5v33.1H70.2z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="5"
      d="M51.6 37.2h49.1v35.6M2.5 72.8V37.2H20M20 72.8c0-4.6 3.7-8.3 8.3-8.3h15c4.6 0 8.3 3.7 8.3 8.3M35.8 49.6v14.9M70.2 48.2h30.5M70.2 59.2h30.5M51.6 25.9h29.2V2.5H41.3v16.1"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="5"
      d="M43.4 18.6H28.3A8.3 8.3 0 0 0 20 27v23h31.6v-23c0-4.6-3.7-8.3-8.3-8.3ZM61.5 25.9v11.3M41.3 2.5l13.8 13.8M53 2.5l13.8 13.8"
    />
  </svg>
)
